import { Observable } from 'rxjs'

export class PedidoAbertoComponent {
    constructor() {
        this.btnFecharPedido = document.querySelector('.pedido-pendente__fechar-pedido');
        this.pedidoPendente = document.querySelector('.pedido-pendente');
        this.init()
    }

    init() {
        if(this.btnFecharPedido) {
            Observable
                .fromEvent(this.btnFecharPedido, 'click')
                .subscribe(event => {
                    this.pedidoPendente.classList.add("pedido-pendente__fechado")
                })
        }
        
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/pedido-aberto.component.js